import * as Newsbrief from '../'
import * as Constants from './constants'

export const addIcon =
  (partnerCode: string) => ({type: Constants.ADD_ICON, partnerCode, value: '', key: ''})

export const deleteIcon =
  (rowId: string) => ({type: Constants.DELETE_ICON, rowId})

export const handleUrlChange =
  (update: Newsbrief.UpdateStateAction) => ({type: Constants.UPDATE_URL_FIELD, ...update})

export const handleDropdown =
  (update: Newsbrief.UpdateStateAction) => ({type: Constants.UPDATE_SOCIAL_MEDIA_DROPDOWN, ...update})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/social-media/actions.ts